export default __webpack_public_path__ + "f75a35c526272d71f5854e3cfb3104f0.svg";